import { render, staticRenderFns } from "./PlatformSupplierIgnoresComponent.vue?vue&type=template&id=16608784&"
import script from "./PlatformSupplierIgnoresComponent.vue?vue&type=script&lang=js&"
export * from "./PlatformSupplierIgnoresComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports